var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_904)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_482_904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16016 13L6.93794 7L1.16016 1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 14,
    fill: "white",
    transform: "translate(0.160156)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_482_904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 14,
    fill: "white",
    transform: "translate(0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.95c6e6ac42ab3c64b18257824233278e.svg";
export { ForwardRef as ReactComponent };